import React from 'react';
// Shared section layout for collection workflows.
import { Box, Paper, Stack, Typography } from '@mui/material';
import { researcherSectionSx, researcherSectionTitleSx } from '../researcherPresentation';

export const extractionActionPanelSx = {
  p: { xs: 1.5, sm: 2 }, border: '1px solid', borderColor: '#e7e8ec', borderRadius: '12px',
  bgcolor: '#fafafb', textAlign: 'center', '& .MuiButton-root': { borderRadius: '9px' },
};

export const exportSectionSx = {
  ...researcherSectionSx,
  mb: 1.5,
};

export function ExportSectionHeading({ step, title, action, centerAction, inline = false }: {
  step: number; title: string; action?: React.ReactNode; centerAction?: React.ReactNode; inline?: boolean;
}) {
  return <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ mb: inline ? 0 : 1.5 }}>
    <Stack direction="row" alignItems="center" gap={1} sx={{ minWidth: 0, ...(centerAction && { flexShrink: 0 }) }}>
      <Box aria-hidden="true" sx={{ width: 26, height: 26, flexShrink: 0, display: 'grid', placeItems: 'center',
        borderRadius: '8px', bgcolor: '#f8eeee', color: 'primary.main', fontSize: 12, fontWeight: 700 }}>
        {String(step).padStart(2, '0')}
      </Box>
      <Typography component="h2" variant="subtitle1" sx={researcherSectionTitleSx}>{title}</Typography>
    </Stack>
    {centerAction && <Box sx={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'center' }}>{centerAction}</Box>}
    {action}
  </Stack>;
}

export default function ExportFormSection({ step, title, action, centerAction, children, inline = false }: {
  step: number; title: string; action?: React.ReactNode; centerAction?: React.ReactNode; children: React.ReactNode; inline?: boolean;
}) {
  return <Paper variant="outlined" sx={{ ...exportSectionSx, ...(inline && { display: 'grid',
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'auto minmax(0, 1fr)' }, gap: 1.5, alignItems: 'center' }) }}>
    <ExportSectionHeading step={step} title={title} action={action} centerAction={centerAction} inline={inline} />
    {inline ? <Box sx={{ minWidth: 0 }}>{children}</Box> : children}
  </Paper>;
}
